
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'

import global from '../../../static/js/global'
export default {
data(){
return{
list:[],
titles:['系统','账单','二手市场','邻里互动'],
page:1,
}
},
methods:{
changeType(index){
let size = this.list.length;
for(let i=0; i < size ; i++){
this.list.pop();
}
this.page = 1;
if(index == 0 ){
this.getData('system',this.page)
}else if(index == 1){
this.getData('charge',this.page)
}else if(index == 2){
this.getData('oldGoods',this.page)
}else if(index == 3){
this.getData('themeShare',this.page)
}
},
noticedetail(id,link){
this.$http.get(global.host + 'noticeCenter/updateRead?noticeId='+ id,{header:{Accept: "application/json; charset=utf-8"}}).then(function(res){
},function(err){
console.log(err)
})
this.$router.push({path:link.replace("movecouplet",'')})
},
getData(type,page,rows=5){
this.$http.post(global.host + 'noticeCenter/findNoticeListByType',{page:page,rows:rows,noticeType:type},{header:{Accept: "application/json; charset=utf-8"}}).then(function(res){
if(res.body.result){
let data = res.body.result;
for(let i = 0; i < data.length ; i++){
this.list.push(data[i]);
}
}
},function(err){
console.log(err)
})
},
},
beforeMount(){
if(this.$router.history.current.path == "/noticeCenter"){
document.title = "通知中心";
}
this.getData('system',this.page);
},
created() {
let self = this;
window.onscroll = function () {
let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
let windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
if (scrollTop + windowHeight == scrollHeight) {
if (!self.loading) {
self.page += 1;
self.getData(self.page);
}
}
}
},
components:{Tab, TabItem, XHeader,XImg,Flexbox, FlexboxItem,XButton,XInput}
}



// WEBPACK FOOTER //
// ./src/components/momentsComponents/remind.vue